const Chatbot_ko_kr = {
	"botName":"Intelbot",
	"botSubTag":"가상 도우미",
	"resetWindow":[
				   {
				   "title":"채팅을 초기화하시겠습니까?",
				   "subtitle1":"채팅 기록을 지우고 다시 시작하려면",
				   "subtitle2":"'예'를 클릭하세요.",
				   "Option1":"예",
				   "Option2":"아니요"
				   }
				  ],
	"closeWindow":[
				   {
				   "title":"채팅을 끝내시겠습니까?",
				   "subtitle1":"채팅 세션을 종료하려면",
				   "subtitle2":"'예'를 클릭하십시오.",
				   "Option1":"예",
				   "Option2":"돌아가기"
				   }
				  ],
	"disclaimerWindow":[
				   {
				   "title":"주의 사항 및 면책 조항",
				   "subtitle1":"인텔 기술은 지원되는 하드웨어, 소프트웨어 또는 서비스 활성화가 필요할 수 있습니다.",
				   "subtitle2":"어떤 제품 또는 구성 요소도 절대적으로 안전할 수는 없습니다.",
				   "subtitle3":"비용과 결과는 다를 수 있습니다.",
			"subtitle4": "© Intel Corporation. 인텔, 인텔 로고 및 인텔 Evo는 인텔사 또는 그 자회사의 상표입니다.<br>*기타 명칭 및 브랜드는 해당 소유업체의 자산입니다. ",
				   "Option1":"돌아가기"
				   }
				  ],
	"botMessageRenderer":[
					{
					"text1":"몇 초 전에",
					"text2":"1분 전",
			"text3": "몇분 전에",
					"text4":"초",
			"text5": "~ 전에",
			"text6": "한 시간 전에",
			"text7": "몇 시간 전",
			"text8": "",
			"text9": ""
					}
					],
	"agentPlaceholder": "대리인",
	"additionalRecommendation":"더보기...",
	"inputPlaceholder":"여기에 입력 시작...",
	"timeoutNotification":"시간 초과 알림",
	"greetingMessage": "인사말 페이지",
	"greetingtext":"안녕하세요, 저는 가상 \n 도우미 인텔봇입니다.",
    "closeChatSession":"채팅 세션 닫기",
	"connectToAgent": "에이전트와 연결",
    "fallbackResponseNo":"대체 응답 없음",
    "resumeConversation":"대화 재개",
    "sessionClosed":"세션 종료",
	"today":"오늘",
	"timeoutMessage":"나는 당신에게서 한동안 답장을 받지 못했습니다. 계속하시겠습니까?",
	"carouselText":"귀하의 선호에 맞는 이상적인 제품은 다음과 같습니다. 마음이 드셨길 바랍니다. 아래 화살표를 사용하여 옵션을 탐색하십시오.",
	"noBattery":"이 PC에는 배터리가 장착되어 있지 않아 항상 플러그에 연결해야 합니다.",
	"noCamera":"죄송합니다, 이 컴퓨터에는 내장형 카메라가 없습니다.",
	"noThunderbolt":"아니요, 이 컴퓨터에는 Thunderbolt™ 기술이 탑재되어 있지 않습니다. ",
	"chatbotPopUp":"도움이 필요하신가요?",
	"spftext": /그러나 나는 당신의 질문을 이해하지 못했습니다./g,
 	"rspftext": "그러나 당신이 찾고 있는 정보를 사용할 수 없습니다",
	"localeString": "ko-KR",
	"userName":"나",
	"fallbackCheck":"나는 당신의 질문을 이해하지 못했습니다",
	"recognitionLocale":"ko",
	"resumeFlow":"흐름 재개",
	"offlineScanText": "오프라인 스캔",
	"feedbackq1":"인텔봇 서비스에 대한 경험을 어떻게 평가하십니까?",
	"one":"1",
	"two":"2",
	"three":"3",
	"four":"4",
	"five":"5",
	"veryPoor":"매우 나쁨",
	"poor":"나쁨",
	"fair":"보통",
	"good":"좋음",
	"excellent":"훌륭함",
	"feedbackq2":"피드백을 부탁드립니다.",
	"enter":"여기에 입력하십시오.",
	"submitfb": "피드백 제출",
	"feedbacktq1": "소중한 피드백 감사합니다!",
	"feedbacktq2":"추가 지원이 필요한 경우 다음 주소로 이메일을 보내주십시오.",
	"feedbacktq3": "support@intel.com.",
	"likeordislike":"도움이 되었나요?",
	"noresume":"대화가 다시 시작되었습니다. 다른 도움이 필요하시면 알려주세요.",
	"offlineSRTmessage":"제품을 찾도록 도와주세요",
	"productRecommendation":"제품 추천",
	"stNotification":"세션 시간 초과 알림",
	"agentConnect1":"에이전트와 연결",
    "fallbackYes":"예",
    "agentGifText":"에이전트에 연결",
	"agentTypingText":"고문이 입력 중입니다",
	"touchscreenEnabled":"이 컴퓨터에는 터치스크린 디스플레이가 있습니다. 스마트폰과 같이 직관적인 제어와 선명하고 생생한 디테일로 PC와 상호 작용합니다. 자세한 정보는 디스플레이 페이지 세부 정보 페이지를 참조하십시오.",
	"noTouchscreen":"이 컴퓨터에는 터치스크린 디스플레이가 없습니다. 자세한 정보는 디스플레이 페이지 세부 정보 페이지를 참조하십시오.",
	"applicationInfoService" : [
		{
			"appName": "ikr-1.3.0-design",
			"sourceName": "fkr",
			"locale": "ko",
		}
	],
	"datalist" : [
        {
           "id": "1", 
            "agentTitle": "더 많은 성능을 원하시나요?",
             "agentText": "13세대 인텔® 코어™ 프로세서를 통해 최고 수준의 스트리밍과 제작, 게임 플레이가 가능합니다."		
        },
        {
			"id": "2", 
            "agentTitle1": "더 많은 멀티태스킹을 원하시나요?",
             "agentText1": "13세대 인텔® 코어™ 프로세서의 고급 멀티태스킹 파워로 다양한 작업을 빠른 속도로 한 번에 처리할 수 있습니다."
        },
        {
			"id": "3", 
            "agentTitle2": "예상을 뛰어넘는 스트리밍 퀄리티",
             "agentText2": "인텔® Wi-Fi 6E(Gig+)의 강력한 연결은 믿을 수 없을 만큼 원활한 스트리밍 경험을 제공합니다."
        },
		{
			"id": "4", 
            "agentTitle3": "콘텐츠 제작 방식을 업그레이드하고 싶으신가요?",
             "agentText3": "13세대 인텔® 코어™ 프로세서의 믿을 수 없을 만큼 강력한 성능을 통해 가장 큰 아이디어를 실현할 수 있습니다."
        },
		{
			"id": "5", 
            "agentTitle4": "성능을 한 단계 더 끌어올리고 싶으신가요?",
             "agentText4": "13세대 인텔® 코어™ 프로세서는 차원이 다른 퍼포먼스로 PC에서 한 번에 더 많은 작업을 처리할 수 있습니다."
        },
		{
			"id": "6", 
			 "agentTitle5": "더 많은 성능을 원하시나요?",
			  "agentText5": "13세대 인텔® 코어™ 프로세서를 통해 최고 수준의 스트리밍과 제작, 게임 플레이가 가능합니다."		
		 },
		 {
			"id": "7", 
            "agentTitle6": "더 많은 멀티태스킹을 원하시나요?",
             "agentText6": "13세대 인텔® 코어™ 프로세서의 고급 멀티태스킹 파워로 다양한 작업을 빠른 속도로 한 번에 처리할 수 있습니다."
        },
		{
			"id": "8", 
            "agentTitle7": "예상을 뛰어넘는 스트리밍 퀄리티",
             "agentText7": "인텔® Wi-Fi 6E(Gig+)의 강력한 연결은 믿을 수 없을 만큼 원활한 스트리밍 경험을 제공합니다."
        }
    
    ],
	"nsfwwords": "애시드|에어로졸|광대 버섯|알코올|메틸트립타민|호모|환각 버섯|암페타민|아질산 아밀|아나볼릭|어나힐레이션|BZP|연초|벤조디아제핀|폭발|블로터|BOM|바운스|버드|대마초|카티논|찰리|칭|담배|코카인|코데인|코크|크랙|크랭크|크리스탈|D2PM|데파스|데스옥시피프라드롤|데졸람|디메토카인|디메틸트립타민|도프|약물|엑스터시|에틸라암|에티세단|에티졸라|에티졸람|가바펜틴|고게인|헤로인|인시티|케타민|LSD|링터스|MDAT|MDMA|MPA|MXE|마리화나|메프|메페드론|메스칼린|메스|메타돈|메스암페타민|메톡세타민|메티론|메틸페니데이트|Mozun|머쉬|NPS|NRG|NRG1|나피론|Nopaine|트랜퀼라이저|오바마|오피에이트|오피오이드|아편유사제|아편|PMA|PMMA|페나제팜|펜사이클리딘|피셉톤|파이페러진|파퍼|팟|쾃|리탈린|로플콥터|로히프놀|로이드|롤렉스|샐비어|시샤|쉬룸|스모크|Sylazepam|TNT|토바코|코카인 흡입|코카인 흡입하기|Ultram|위즈|알콜|암페타민|암페타민|아야와스카|맥주|벤조디아제핀|벤질피페라진|알코올 음료|술|뷰테인|부틸론|카나비노이드|대마초|카티논|코카인|코데인|코냑|크랙|크랭크|크리스탈|덱세드린|덱시|덱스트로암페타민|디아모르핀|도프|약물|마약|엑스터시|에페드린|에틸페니데이트|포름알데히드|간자|좆같아|해시|해시시|허브|헤로인|후카|하이드로코돈|indopan|흡입약|케타민|lsd|마리화나|mdma|메페드론|메스칼린|메스|메스암페타민|메틸나프티데이트|메틸페니데이트|모르핀|버섯|아편|페이오트|포크|프로필페니데이트|실로시빈|피로발레론|카드카|캇|리탈린|럼|스컹크|스모크|스피드볼|탈윈|토바코|비아그라|바이코딘|보드카|위드|위스키|위스키|위스키|위즈|와인|자낙스|자일라진|강간범|살인범|살인자|강도|범죄자|테러리스트|암살자|학대범|성추행범|전과자|소독된|소독|제노사이드|제거|세척|세척하다|제거하다|난도질하다|난도질|쏘다|총상을 입은|찌르다|찔린|살해하다|살해된|대참사|박살내다|박살난|차별하다|차별당한|차별|박해당한|박해|고발당한|고발|노예|노예 제도|태우다|타다|궁둥이|아 썅|썅|맙소사|LBGT|엉덩이|알라|항문|후장|궁둥이|아랍|아랍인|궁뎅이|궁둥이|엉덩이|방뎅이|병신새끼|븅신새끼|병신|병신놈|븅신놈|썅년|슴가|썅년|썅년|불알|부랄|개자식|수간의|수간|귀두|수간의|수간|썅년|샹련|성경|성경|썅년|썅것|개년|썅년|지럴|지랄|옘병|옘병할|오럴|사까시|구강 성교|호모|씨부랄|씨부럴|폭탄|발기|슴가|가슴|젖통|젖가슴|빨통|젖탱이|유방|보지|불교|등신|놈팽이|영계|엉덩이|똥꼬|성가신 놈|항문플러그|좆|좆같은 놈|보지털|잦|중국인|짱깨|그리스도|기독교인|기독교인|보지|클리|클리|음핵|클리토리스|씹창련|좆|좆병신|존나 병신|같잖은 놈|꼴같잖은 놈|좆|좆같은 놈|좆같은|좆같은 새끼|좆같음|좆같은 놈|조까튼놈|조까튼 새끼|좃|꼴같잖은 새끼|죶같은놈|흑노예|좆|젠장|정액|사정하는 놈|사정|좆물|싸지르기|커널링구스|오럴섹스|오럴 섹스|씹창년|보빨|보빨러|보지 빨기|씹창련|시알리스|사이버떡치기|사이버섹스|사이버섹스의|사이버 떡 치는 놈|사이버떡치는놈|사이버떡치기|곧휴|다에시|제기랄|고추|좆대가리|딜도|딜도|딩크|딩크|병신놈|꼬튜|공공장소 섹스|공공장소섹스|당나귀 수간범|찌랭이|찌질이|레즈비언|사정하다|사정한|사정하다|사정하기|싸기|사정|싸다|봊|호모|호모짓|똥꼬충|호모새끼|호모놈|호모|호모놈|호모놈|호모|보지|대음순|좆박은 놈|보지|씹돼지|싯팔|싯팔놈|시팔|쉬펄|쉬펄새끼|애액 핥기|좆빨기|펠라치오|보지 쑤시기|손으로 해주는|손으로 쑤시는 놈|손으로 쑤시는 놈|손으로 쑤시기|손으로 애무|주먹 넣기|주먹을 넣는|주먹으로 쑤시는 놈|주먹으로 쑤시는 놈|주먹으로 쑤시기|주먹으로 쑤시기|주먹 넣기|소중이|쎅쓰|쉐끼|시발|색히|박힌|새끼|새끼|머저리|머저리|씨벌|졸라|졸라|개같은니미씨발놈|좆같네|시발|띨빡이|띨빡|게이 후장 섹스|게이 후장 섹스하는 놈|씹|시벌롬|씨발롬|죨라|씹|띨빡이|띨빡|씹|씨부럴놈|갱뱅|갱뱅하는|갱뱅|게이 새끼|게이새끼|게이섹스|후장 벌린 놈|맙소사|존나빌어먹을|졸라 빌어먹을|맙소사|복음|복음|하급 인생|굴라크|굴라크|할랄|섹스|증오|보추|이성애자|이성 연애자|이성 연애자|힌두교|히틀러|창년|창뇬|음탕한 년|대참사|호모|동성애자|동성애자|창녀|개꼴린|꼴린|뜨거운섹스|이민자|이민자|이민|isis|이슬람|하찮은놈|쪽바리|여호와|얼간이|예수|유대인|유대인|좆물|좃물|좆물|좃물|쟞이|살인자|살인|빠가|빡대갈|빠가놈|빡대갈놈|빡대가리|게이자식|게이 자식|육봉|콘돔|콘돔|코셔|좆물|싸는 놈|싸기|좆물|보지 핥기|ㅁ1친년|ㅁ1친뇬|음순|음란|레즈비언|레즈비언들|졸라 웃김|욕정|ㄴ1ㅁ1|ㄴ1미|딸 잡다|딸잡다|딸치다|마호마|마호마|마조히스트|마스터|딸치다|딸이치다|딸딸이 치다|자위하다|자위|자위|자기위로하다|멕시코인|느금|니미럴|니미시벌|무슬림|느금마시발|느금마시발럼|느금마시발럼|느금마시발놈|느금마|느그애미|느그애미|느그애미시벌|느그애미시발|느그애미시발|느그애미시팔|엄마|니애미씨발|니애미싯팔|니애미씨발놈|니애미씨발놈|니애미시부럴|시발|시발|씨발놈|씨발|뷰지|살해하다|이슬람교도|이슬람교도|니 애미|니 애미 시발|니 애미 싯팔|느그 애미|느그 애미 시발|깜ㄷ1|깜ㄷㅣ|나치|나치|깜댕이|시커먼스|깜둥이놈|깜둥이넘|깜둥이새끼|깜둥이색히|깜둥이|깜둥이|천치|바보 천치|게이새끼|게이 새끼|똘추새끼|똘추|오르가슴|오르가슴|오르가즘|오르가즘|정교회|얃옹|파키놈|파키놈|파키스탄인|불알|꽈추|음경|남창|폰섹스|쎅스|쎅|쎅스하는|절라|쎅쓰하는|줠라|쎅|쌕쓰|개씨발놈|바람둥이|빡쳐|빡친|빡치게 하는|빡치게 하는|빡치다|음순|열받은|열받은|열받다|똥|야동|포르노|음란물|포르노|꼬추|꼬추|얏옹|개신교|개신교도|음모|씹구멍|씹 구멍|씹 구멍|보지|보지|쿠란|쿠란|인종 차별|인종 차별주의자|직장|종교|저능아|후빨|후장 빨기|사디스트|쥬지|성관계|새끼|새끼|거시기|정액|섹스|썅|썅|썅|박다|박은 놈|박기|박기|쉬메일|썅|신도|썅|좆가튼놈|샹|좆된|좆가튼|쒸팍|쒸불|대가리에 똥만 찬 놈|똥싸기|똥싸기|똥|똥싼|똥싸개|똥싸개|똥누기|똥누기|개똥 같은|쫄보|쫄보|갈보|걸레|걸레|꼬카인|외설|씹구멍|아들|또라이|좆물|ㅉ1ㅉ1|ㅉ1찌|탈무드|젖꼭지|꼭쥐쓰|테러리즘|테러리스트|고환|고환|맘마통|젖치기|찌찌|젖|찌찌|젖치기하는 놈|찌찌|젖치기|파이즈리|파이즈리|율법|얼빠진 놈|트랜스젠더|성전환자|성전환자|쓰리섬|똥|등신|등신|등신|등신|환멸나는 놈|환멸나는 놈|ㅂ1아그라|ㅂ1아그라|질|비아그라| 음문|겁쟁이|똘똘이|딸잡다|딸잡이|딸잡는|창녀|창녀|고추|성인용|xxx|조로아스터교|민주주의자|공화주의자|민주주의자|공화주의자|공산주의자|공산주의자|공산주의|자유주의자|신보수주의자|신보수주의자|신자유주의자|신자유주의자|신자유주의|힐러리|정치인|정치|정치|물욕이 많은|긍정적인|법정 조언자|항소의|약속|도용|귀족|공소장|호주인|권위주의적인|AGBV|블록|자본주의|CIA|센트럴|시민의|일반|공산주의|다국 간의|연맹|헌법|동의|보수주의|협력하는|법정|범죄자|민주주의|민주주의의|국제 간 긴장 완화|외교|파시즘|연방 정부의|연방주의|연방 국가|정부|이데올로기|이니셔티브|파시즘|케인스 주의의|경제학|입법부|정당성|자유주의의|자유주의|자유의지론|자유|제한됨|다수결주의|통화의|도덕상의|자연의|핵|의회의|당파심|다원주의|정치문화|정치적|정치|정치적|최다 이용|대통령의|진보적인|비례적인|비준|국민 투표|퇴보하는|대표하는|분리|쉐이즈|보조금|투표권|패권|신권정치|전체주의의|단원제의|통합된|민주주의자|공화주의자|정치|정치인|힐러리|스타인|카시크|허커비|클린턴|트럼프|푸틴|보리스|칼람|아탈|바지파이|베나지르|아르빈드|마하트마|JFK|라루|야다브|나렌드라|디즈레일리|처칠|파스완|우펜드라|쿠슈바하|마야와티|사지드|대처|사예다|바로네스|메이라|바크먼|알타프|찬드라|셰카르|잭|고우다|아불|마우두디|시타람|아지트|이언|낙태의|아브라함의|면죄 선언|시종|행동주의|아드한|양자론|재림절|아프리카인|알라|아멘|무천년설|아미시파|재세례파|신비적 해석|조상|천사론|영국 성공회|앵글로|애니미즘의|영혼 절멸설|수태 고지|노아의 홍수 이전의|성가|인류학|의인화|침례교 반대론|기독교 반대론|이단 반대론|국교 폐지 조례 반대론|도덕률 폐기론|안디옥의|반삼위일체론|종말|종말론적|만물회복설|경외 성경|변증론|옹호자|변절자|사도|사도|사도의|발현|아폴리나리즘|대천사|대주교|대주교의 관할 구|집정관|아라한|아리우스의|아마겟돈|아르미니우스설|아리아인|승천한|승천|금욕주의|아슈라|아쉬람|추정|점성술|무신론|무신론자|아틀란티스|속죄|특성|자력구원론|아이얌|백마스킹|바이사키|바포메트|침례|침례교|낳다|독생자|벨테인|바가바드|성경|성서의|성서주의|성서 숭배|성서학|주교|이신론자|흑인|신성 모독|축복|피맛|블뤼트|보우디|보살|브라마|브라민|세뇌|북머니즘|부처|불교|도당|칼리프|칼뱅주의|시성|추기경|교리 문답|가톨릭|사제|중단론|차크라|성배|영적 교신|카리스마파의|천년 왕국설|손금 보기|그리스도 형제파|기독교인|기독론|후파|교회|할례|성찬식|최후 공통 조상|동시에 만든|조건적 영혼 불멸설|보수적|동일한 본질|성체 공존설|명상|상황화|회심주의|성체|우주 발생론|우주 생성론|의회|전 기독교적인|약속|신경|복음주의|십자가상|십자가에 못 박힘|크리스탈|컬|컬트|달라이|도교|다르|다사|디컨|컬트|죽음|종교적인|십계명|역회심|하느님|신|조물주|악령|마귀의|의무론의|디오실|타락|디프로그래밍|악마|다르마|디아스프라|통관 복음서|이분|디다케|교구|두 본성|두 본성론|해리|디사이플교회|국교 제도 폐지|국교 제도 폐지론자|지위 박탈|천계적 사관주의자|해리|점|디왈리|그리스도 가현설|교리|도그마|도나투스주의|최후의 날|안식|다운그레이더|다우징|드루이드|이원론|남녀 쌍신론|두세라|에비온파|교회학|절충|전 기독교적인|이드|자기 해석|주교구|에피클레시스|에피클레시스|미국 성공회|인식론|종말론|종말론의|밀교|본질주의|윤리|윤리적인|성찬식|우생학|안락사|복음주의|복음 전도|복음을 전하다|승영|파문|성서 해설|퇴마 의식|형식주의|신앙|율법학자|운명론|파트와|페미나치|페미니스트|풍|필리오케|프리메이슨 제도|자유사상가|프럼|근본주의자|푸루|게헤나|게니자|제노사이드|비유대인|천동설|풍수지리|빈민가|길가메시|방언|영적 인식|맙소사|여신|복음|구르드와라|하데스|하디스|메카 순례|메카 순례|할라카|할랄|할렐루야|할로윈|약혼|하그리브스|이교도|천국|청소년 성애자|헬레니즘|구약 성서의 처음 7서|이교의|이교 연구자|이교 연구|헤레티|해석학|헤르메스주의|이성애주의|이성 연애자|구약 성서의 처음 6서|히잡|히즈라|힌두교|대참사|신성한|동종 요법|동성애 혐오|이슬람 낙원의 미녀|후드드|위격적|예수|유다인의 임금, 나사렛 사람 예수|이람|일루미나티|이맘|원죄 없는|내재|절박|부도덕|불멸|완전무결|성육신|악령|성서 무류설|불신자|초기|종교 재판|영감|중재|교회 제명 명령|제명|종파를 초월한|종교 일치론|이종교 간의|포도주에 성찬의 빵 적시기|배교|이슬람교|이슬람교의|이슬람교도|이슬람 증오|자기 해석|카바|카발|카마|카르마|신성 포기|케투바|쿠트바|키파|키파|코이네|코이노니아|코란|코셔|크리슈나|크사나|LDS|LXX|성구|성구집|법치주의|형제 역연혼|자유주의의|해방|예배식|주님|루시퍼|루터교|주류|악한|만달라|만답|마니교|현시|만트라|마리아 수도회|마스지드|프리메이슨의|메노파 교도|메시아|메시아의|메타 윤리|감리교 신자|미드라시|미흐라브|무천년설|미나테트|민얀|기적|미사 전서|그리스도 양태론|모하메드|모크샤|단일신론|수도원|일원론|일신 숭배|그리스도 단성론자|그리스도 단성론|일신교|도덕상의|도덕성|모스크|쓰리썸|다종교|배교|배교|이슬람|불교의 악마|주술|묵주|신 이교주의|신 유신론|유신론|니카|허무주의자|열반|규범적인|숫자점|OSAS|오컬트|올레|올림|전능 선행|전능|편재|전지전능|일체|오푸스|정통파의|평화주의|유아 세례|파고다|범신론|범신론자|판테온|파라처치|파루시아|처녀 생식|유월절|잘못을 저지르기 쉬움|유아 세례|소아 성애자| 펠라기우스주의|속죄|오각별|펜타그램|성령 강림절|인내|바리새인|육체의|경건|성령론|정치적으로|일처다부제|일부다처제|일부다처|다신론|포라이모스|후천년설|기도|운명 예정설|장로교 교인|전제주의|과거주의|과거주의자|사제직|낙태 지지자|낙태 찬성파|낙태를 반대하는|신성 모독적인|진보적인|유대인 학살|예언|개종시키다|개신교|프로토콜|원시복음|설교단|연옥|피라미드|인종 차별|라마단|황홀경|날아다니는 스파게티 괴물교|날아다니는 스파게티 괴물 숭배|라스타파리안주의|이성주의|환생 요법|개정|충고|보복|반사요법|종교 개혁|개량된|재생|종교|종교|종교적인|종교주의|만민 구제설|퇴보|렘|옳은|의식 절차|묵주|관례화|섹시|러셀파|안식일|안식일 엄수주의|안식일|사벨리우스설|성례|사다카|사두개파|사하바|성자|사즈다|사랏|구원|구제를 베푸는|사마디|서우인|삼사라|신성화|산헤드린|산테리아|사탄|사탄의|악마 숭배|희생양|종파 분립|성서|교령회|세속적인|세속화|영원한|유월절|셀라|70인역|뱀|서비스|성차별|샤리아|사탄|양|셰마|양치기|신도|쇼아|기피|시크교|스칸다|소돔 사람|지점|마법|구원론|심령술|심령론|영성|스리바차|스와스티카|고정 관념|성혼|서브리미널|실체|여자 악령|부주교|수피교|수니파|슈라|수트라|스와스티카|시나고그|제설 통합의|신인 협력설|종교 회의|체계적인|탈릿|탈무드|타나크|도교|목적론의|신전|테러리즘|테트라그램|테트라그라마톤|원문의|유신론자|신권정치|신정론|신학|신의 출현|신성화|신격화|신성시|참여|치료법의|티쿤|십일조|옥스퍼드 운동|전통주의|전통|전통주의|초월|변모|환생|성변화|고난|삼분법|삼위일체|삼위일체|삼신론|불신하는|무조건적인|정체불명의|단일 인격성|유니테리언교도|보편 구제론|보편 구제론|용서할 수 없는|우파니샤드|웁셰린|우술|베다|용서할 수 있는|동정녀|비슈누|보둔|의지주의|부두교|불가타 성서|발푸르기스의 밤|남자 마법사|망루|웨스트민스터|마법 숭배|마법 숭배|태양 운행과 반대 방향으로|마녀|주술|우머니즘|우머니스트|여성|숭배|나무 숭배자|여호와|야물커|크리스마스|광신도|국교 폐지 조례 반대론|불신자|의식|바하|바하올라|크툴루|슈브|니알라토텝|정액|약해빠진 놈|약해빠진 놈|계집애같은 놈|계집애같은 놈|의지가 약한 보수 정치가|거세한놈|거세한놈|거세한 놈|비아그라|젠장|젠장|분별없는 진보주의자|퇴보하는|사회 정의|텀블리나|깨어있는|미국을 다시 위대하게 만들자|미국을 다시 위대하게 만들자|트롤|졸라 많은|봇|러시안 봇|악플 부대|담배|파시스트|팔랑귀|다자간 연애|게이들|바람둥이|바람둥이|죽음|바람피우기|콘돔|콘돔"
}
